import React, { ComponentType } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

export const withMuiPickersUtilsProvider = (Component: ComponentType) => (props: any) => {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Component {...props} />
    </MuiPickersUtilsProvider>
  );
};
